// extracted by mini-css-extract-plugin
module.exports = {"OurWork":"style_OurWork__3Zth0","ButtonLoad":"style_ButtonLoad__2K4Es"};